import { useSelector } from "react-redux";
import logoHeader from "../../../assets/images/logo-header.png";

const MAZAD_ELKHORDA_URL = "https://mazadelkhorda.com/";

function MazadElkhordaLink() {
  const { dir } = useSelector((state) => state.language);
  const isRtl = dir === "rtl";

  return (
    <a
      href={MAZAD_ELKHORDA_URL}
      target="_blank"
      rel="noopener noreferrer"
      className={`mazad-elkhorda-link${isRtl ? " mazad-elkhorda-link--rtl" : ""}`}
      aria-label="Mazad Elkhorda"
    >
      <img src={logoHeader} alt="Mazad Elkhorda" />
    </a>
  );
}

export default MazadElkhordaLink;
